import { VueTemplate } from '../VueTemplate';
import { ContentStoryTemplateData } from '../../../Widget/ContentWidget/types';

/**
 * Template class for content widget templates created using Vue
 */
export class VueContentTemplate extends VueTemplate<ContentStoryTemplateData> {
    /**
     * Expected format of the dataStore
     *
     * All dataStore for Content template must be of this format so that
     * templates are consistent
     * @see [Vue Prop Validation]{@link https://vuejs.org/v2/guide/components-props.html#Prop-Validation}
     */
    properties: {
        stories: ArrayConstructor;
        wid: StringConstructor;
        widget: ObjectConstructor;
        metadata: ObjectConstructor;
        Widget: ObjectConstructor;
    } = {
        //Array of content stories
        stories: Array,

        //The Widgets id, used for handlebars but carried over to Vue.  Deprecated
        wid: String,

        //reference to the widget object.  Deprecated, pass specific props required
        widget: Object,

        //Other miscellaneous data
        metadata: Object,

        Widget: Object, // { Id: <widget-id> }
    };
}
